import React, { useEffect, useState } from "react";
import Service from "../Service/http";
import Util from "../Service/util";
import exportFromJSON from 'export-from-json'; 
import { toast } from "react-toastify";
import { FadeLoader } from "react-spinners";

const Filter = (props) => {
  const service = new Service();
  const util = new Util();

  let [value, SetValue] = useState('fulllist');
  let [data, SetData] = useState(null);
  let [loading, SetLoading] = useState(false);


  const getSitesHandles = ()=>{
    service.get("api/sites/handles").then(json=>{
        const data = json.result ; 
        const fileName = 'download'  
        const exportType = 'csv'  
        exportFromJSON({ data, fileName, exportType }) ;
        SetLoading(false);
    }).catch(error=>{
        SetLoading(false);
        console.log(error);
    })

  }

  const getLeaderboardData = ()=>{
    service
      .get("api/leaderboard")
      .then((json) => {
        const data = json ; 
        const fileName = 'download'  
        const exportType = 'csv'  
        exportFromJSON({ data, fileName, exportType }) ;
        SetLoading(false);
      })
      .catch((error) => {
        SetLoading(false);
        console.log(error);
      });
  }


  const downloadData = ()=>{

    SetLoading(true);

    if(value==="siteshandle"){
        getSitesHandles()

    }else if(value==="cpleaderboard"){
        getLeaderboardData()

    }else{
    service.post("api/filter/download/list",{ value })
    .then(json=>{
        const data = json ; 
        const fileName = 'download'  
        const exportType = 'csv'  
        exportFromJSON({ data, fileName, exportType }) ;
        SetLoading(false);
    }).catch(error=>{
        SetLoading(false);
        console.log(error);
    })}

  }


  return (
    <div className="container m-4">
        {loading?<div className="text-center"><FadeLoader color={"green"}/></div>:
      <div className="row  center">
        <div className="form-group col-sm-4 text-success ">
          <select 
          className="form-select text-success " 
          id="exampleSelect1"
          onChange={(e)=>{
            SetValue(e.target.value);
          }}
          >
            <option value={"fulllist"}> Full Roll-No & Emil List</option>
            <option value={"signedlist"} > Signed-Up Users With Roll-No Filled</option>
            <option value={"signednotfilled"} > Signed-Up Users Without Roll-No Filled</option>
            <option value={"notsignedlist"} > Not Signed Up Users</option>
            <option value={"notinlist"} > Not In List But Singed Up</option>
            <option value={"duplicaterollno"} > Duplicate Roll No</option>
            <option value={"allsiteHandlesNotFilled"}> All Sites Handles Not Filled</option>
            <option value={"cpleaderboard"} > Cp Leaderboard</option>
            <option value={"siteshandle"} > Sites Handles</option> 

          </select>
        </div>
        <div className="btn btn-success col-sm-2"
        onClick={()=>{
            downloadData();
        }}
        > Download </div>
      </div>
      }
    </div>
  );
};

export default Filter;
